export const i18nPdfPage = {
  generatingPreview: 'Generating preview...',
  coverTitle: 'Monthly Report',
  headerTitle: 'Performance Monitoring Report',
  pageTitles: {
    1: 'System / Subsystem',
    2: 'Cases (summary view)',
    3: 'Cases (in detail)',
    4: 'External References',
  },

  system: 'System/Subsystem',
  dimensions: 'Dimensions',
  category: { RERT: 'Rotating equipment' },
  cover: {
    documentNumber: 'Document Number',
    issueReason: 'Issuer Reason',
    revision: 'Revision',
  },
  name: {
    title: 'Case Name',
  },
  severity: {
    title: 'Severity',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    very_high: 'Very High',
    normal: 'Normal condition',
  },

  status: {
    title: 'Stage',
    actions: 'Actions',
    diagnosis: 'Diagnosis',
    feedback: 'Feedback',
    closed: 'Closed',
    canceled: 'Canceled',
  },
  normal: 'Normal condition',
  label: {
    diagnosis: 'Diagnosis',
    detailing: 'Detailing',
    deviation_start: 'Deviation Start',
    deviation_end: 'Deviation End',
    condition_evaluation: 'Condition Evaluation',
    recommended_action: 'Recommended Action',
    action_status: 'Action Status',
    sap_note: 'SAP note / Status',
  },
  dimensions_label: {
    dynamic_condition: 'Dynamic Condition',
    auxiliary_system: 'Auxiliary System',
    oil_analysis: 'Oil Analysis',
    process_condition: 'Process Condition',
  },
  summary: {
    cases: {
      title: 'Cases',
      total: 'Total',
    },
    severity: {
      title: 'Severity',
      very_high: 'Very High',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      very_low: 'Very Low',
    },
    stage: {
      title: 'Stage',
      diagnosis: 'Diagnosis',
      actions: 'Actions',
      feedback: 'Feedback',
      closed: 'Closed',
    },
  },
};
